/* socket api change to http api request */
import request from "@/utils/request";

export async function getMessageByRoom(params) {
  return request('/apidv/commu/get/messages', {
    method: 'POST',
    data: params || {},
  });
}